import { PackageType } from "../assignments/assignment";
import {
  BooleanOperator,
  DateOperator,
  ListOperator,
  NumericOperator,
  StringOperator,
} from "../users/users";

export interface ReportTemplateQueryParams {
  search?: string;
  orderBy?: string;
  sort?: string;
  limit?: number;
  offset?: number;
}

export enum ReportTemplateTypeEnum {
  USER_REPORT = "User report",
  ASSIGNMENT_ACIVITY_REPORT = "Assignment activity report",
  USER_ACTIVITY_REPORT = "User activity report",
  ASSESSMENT_REPORT = "Assessment report",
}
export interface GetReportTemplatesResult {
  ReportTemplateUid: string;
  name: string;
  type: ReportTemplateTypeEnum;
  createdBy: string;
  lastViewed: string;
  lastUpdated: string;
}
export interface GetReportTemplatesPagintedResult {
  count: number;
  previousPage: string;
  nextPage: string;
  rows: GetReportTemplatesResult[];
}
export interface getReportTemplateDdlResult {
  reportType: DdlResult;
  portal: GetPortalsDdlReportResult[];
  userAttribute: AdvancedDdlItems[];
  userActionType: DdlResult;
  userActionDate?: UserAssignmentDateRes;
  userAssignment: DdlResult;
  userAssignmentDate: UserAssignmentDateRes[];
  userAssignmentStatus: DdlResult;
  progressStatus: DdlResult;
}

export interface UserAssignmentDateRes {
  attributeKey: string;
  attributeName: string;
  dataType: string;
  filterGroup: string;
}
export interface DdlResult {
  attributeKey: string;
  attributeName: string;
  dataType: string;
  filterGroup: string;
  result: DdlListResult[];
}

export interface DdlListResult {
  key: string;
  value: string;
  status?: string;
}
export interface AdvancedDdlItems {
  filterGroup?: string;
  attributeKey: string;
  attributeName?: string;
  dataType: string;
  result?: DdlListResult[];
}
export interface GetPortalsDdlReportResult {
  portalUid: string;
  name: string;
  subPortals?: GetPortalsDdlReportResult[];
}

export type Operator =
  | StringOperator
  | NumericOperator
  | DateOperator
  | BooleanOperator
  | ListOperator;

export interface ReportTemplateBodyParams {
  reportTemplateUid?: string;
  name?: string;
  type?: ReportTemplateTypeEnum;
  groupByPortal?: boolean;
  filters?: ReportTemplateFilterResult[];
}
export interface ReportTemplateFilterResult {
  filterGroup: string;
  attribute: string;
  operator: Operator | "";
  value: string[] | string;
}
export interface GetReportTemplateResult {
  reportTemplateUid?: string;
  name?: string;
  type?: ReportTemplateTypeEnum;
  groupByPortal?: boolean;
  filters?: ReportTemplateFilterResult[];
}

export interface ReportTemplateRemoveBodyParams {
  reportTemplateUids: string[];
}

export enum ProgressStatus {
  NOTSTARTED = "Not-Started",
  INPROGRESS = "In-Progress",
  COMPLETED = "Completed",
  FAILED = "Failed",
  NOTSTARTED_OVERDUE = "Not-Started(Overdue)",
  INPROGRESS_OVERDUE = "In-Progress(Overdue)",
  FAILED_OVERDUE = "Completed(Overdue)",
}

// User Report
export interface userReportCompleteType {
  finResult: {
    appliedFilters: appliedFiltersType;
    reportData: userReportType[] | userReportByPortalsType[];
  };
}

export interface userReportByPortalsType {
  portalUid: string;
  name: string;
  parentPortalUid: string;
  users: userReportByPortals[];
}

export interface userReportByPortals {
  userUid: string;
  firstName: string;
  lastName: string;
  email: string;
  registeredAt: string;
  userAttributes: Record<string, string>;
}
export interface userReportType {
  portalUid?: string;
  name: string;
  userUid: string;
  firstName: string;
  lastName: string;
  email: string;
  parentPortalUid: string;
  userAttributes: Record<string, string>;
  registeredAt: string;
}

export interface appliedFiltersType {
  general?: generalAppliedFilters;
  userAttributes?: Record<string, string>;
  assignments?: userAssignmentAppliedFilters;
}

export interface generalAppliedFilters {
  Portal?: string;
  GroupByPortal?: string;
  UserActivity?: string;
  UserActivityDateFrom?: string;
  UserActivityDateTo?: string;
  UserActivityDate?: string;
}
export interface userAssignmentAppliedFilters {
  Assignment?: string;
  AssignmentStatus?: string;
  ProgressStatus?: ProgressStatus | string;
  AssignmentDateTo?: string;
  DueDate?: string;
  CreatedAt?: string;
  StartDate?: string;
  EndDate?: string;
}

// Assignment Activity Report
export interface assignmentActivityReportCompleteType {
  finResult: {
    appliedFilters: appliedFiltersType;
    summary?: summaryType[];
    reportData:
      | assignmentActivityByUserReportType[]
      | assignmentActivityReportByPortalsType[];
  };
}
export interface summaryType {
  portalAssignmentUid: string;
  title: string;
  avgScore: number | null;
  avgCompleteTime: number | null;
  minCompleteTime: number | null;
  maxCompleteTime: number | null;
  assignedUsers: number;
  completedUsers: number;
  pendingUsers: number;
  overdueUsers: number;
  SKU: string;
  code: string;
  type: string;
}
export interface assignmentActivityByUserReportType {
  userUid: string;
  portalUid: string;
  portalName: string;
  parentPortalUid: string | null;
  firstName: string;
  lastName: string;
  email: string;
  userAttributes: Record<string, string>;
  assignments: userAssignments[];
}
export interface AssignmentRecord {
  recordUid: string;
  userAssignmentUid: string;
  progressStatus: ProgressStatus;
  score: number;
  bestScore: number;
  recordNo: number;
  attempts: number;
  timeSpent: number;
  dueDate: string | null;
  startDate: string | null;
  completionDate: string | null;
  version?: string | null;
  ackResponse: boolean | null;
  certificateUid?: string | null;
  scores?: string;
}

export interface userAssignments {
  userAssignmentUid: string;
  portalAssignmentUid: string;
  title: string;
  type: string;
  progressStatus: ProgressStatus;
  bestScore: number;
  scores: string;
  attempts: number;
  dueDate: string | null;
  startDate: string | null;
  completionDate: string | null;
  timeSpent: number;
  SKU: string;
  code: string;
  certificateUid: string | null;
  records?: AssignmentRecord[];
  packageType: PackageType;
}

export interface assignmentActivityReportByPortalsType {
  portalUid: string;
  name: string;
  parentPortalUid: string | null;
  users: assignmentActivityUsers[];
}

export interface assignmentActivityUsers {
  userUid: string;
  firstName: string;
  lastName: string;
  email: string;
  userAttributes: Record<string, string>;
  assignments: userAssignments[];
}

// User Activity Report
export interface userActivityReportCompleteType {
  finResult: {
    appliedFilters: appliedFiltersType;
    reportData: userActivityReportByPortalType[] | userActivityReportUsers[];
  };
}

export interface userActivityReportByPortalType {
  portalUid: string;
  portalName: string;
  parentPortalUid: string;
  users: userActivityReportUsers[];
}

export interface userActivityReportUsers {
  portalUid?: string;
  parentPortalUid?: string;
  portalName?: string;
  userUid: string;
  fullName: string;
  email: string;
  activity: string;
  activityDetails: string;
  activityTimestamp: string;
  activityPortal: string;
}

export interface AssessmentReportQueryParams {
  userAssignmentUid: string;
  packageType?: PackageType;
}

export interface AssessmentReportQuestion {
  questionNo: string;
  startDateTime: string | null;
  question: string | null;
  userResponse: string | null;
  correctResponse: string | null;
  result: boolean | null;
}

export interface AssessmentReportAttempt {
  userAssignmentAssessmentUid: string;
  attemptNumber: number;
  isLatest: boolean;
  isFirst: boolean;
  status: AssessmentProgressStatus;
  score: number | null;
  started: string | null;
  lastAccessed: string | null;
  completed: string | null;
  timeSpent: number | null;
  questions: AssessmentReportQuestion[];
}

export interface AssessmentReportPdfData {
  ackResponse: boolean | null;
  comment: string | null;
  submittedAt: string | null;
}

export interface AssessmentReportResult extends Partial<AssessmentReportPdfData> {
  userAssignmentUid: string;
  assignment: string;
  certificateUid: string | null;
  firstName: string;
  lastName: string;
  attempts?: AssessmentReportAttempt[];
}

export enum AssessmentProgressStatus {
  PASSED = "passed",
  FAILED = "failed",
  NOT_COMPLETED = "not-completed",
  COMPLETED = "completed",
}
